import React, { useState } from 'react';
import axios from '../../api/axios';
import '../../styles/loginPage.css'
import { Link, useNavigate } from 'react-router-dom';
import { notify } from '../toast';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setLoading(true);
      const response = await axios.post('/login', { email, password });
      const accessToken = response?.data?.token;
      sessionStorage.setItem('accessToken', accessToken);

      if (response?.data?.firstLogin) {
        navigate('/reset');
        notify('info', 'Please change your password');
      } else {
        navigate('/');
        notify('success', response?.data?.success);
      }

    } catch (err) {
      const errorMessage = err?.response?.data?.message || err?.message || 'error fetching server information';
      notify('failed', errorMessage)
    } finally {
      setLoading(false);
      setEmail('');
      setPassword('');
    }
  };

  return (
    <div className="body-login">
      <div className='login-container'>
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>

          <div>
            <label htmlFor="email">email</label>
            <input
              type="email"
              id="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div>
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? <span className="spinner" /> : 'Login'}
          </button>

        </form>

        <div className="links">
          <Link to={'/forgot'}>Forgot Password?</Link>
          <Link to={'/signup'}>Register</Link>
        </div>

      </div>
    </div>
  );
};

export default LoginPage;
